<template>
  <div class="billingSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Select
          v-model="billingType"
          filterable
          :placeholder="$t('alarms.billing.filterByBillingType')"
          :transfer="true"
        >
          <Option value="">{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in billingTypeList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
        />
      </Col>
    </Row>
    <Row :gutter="4" index="" style="margin-top:10px">
      <Col span="4">
        <Select
          v-model="resourceType"
          filterable
          :placeholder="$t('resourceLifecycle.filterbyResourceType')"
          :transfer="true"
        >
          <Option value="">{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in resourceTypeList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- 监控指标 -->
      <Col span="4">
        <Select
          v-model="monitorIndex"
          :placeholder="$t('alarms.billing.pleaseSelectMonitorIndex')"
        >
          <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in monitorIndexList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="alertRuleSearchKey"
          :placeholder="$t('alarms.common.filterByAlertRuleName')"
        />
      </Col>
      <Col span="4">
        <Button type="primary" @click="getData">{{
          $t("message.select")
        }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableBillingWarning from "../billing/TableBillingWarning";
var tableBillingWarning = TableBillingWarning;
var billingWarningSearch = {};
export default {
  name: "BillingWarningSearch",
  data() {
    return {
      monitorIndex: "",
      monitorIndexList: [],
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      alertRuleSearchKey: "",
      alertRuleSearchName: "",
      resourceTypeList: [],
      resourceType: "",
      accountName: "",
      billingType: "",
      billingTypeList: [
        {
          id: 0,
          name: this.$t("alarms.billing.singleAccount")
        },
        {
          id: 1,
          name: this.$t("alarms.billing.accountGroup")
        }
      ]
    };
  },
  beforeCreate: function() {
    billingWarningSearch = this;
  },
  mounted: function() {
    this.queryResourceType();
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
    this.searchMonitorIndex();
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("billingType", this.billingType);
      eventBus.$emit("resourceType", this.resourceType);
      eventBus.$emit("monitorIndex", this.monitorIndex);
      eventBus.$emit("alertRuleSearchName", this.alertRuleSearchKey);
      tableBillingWarning.methods.showAll();
    },
    // 查询监控指标
    searchMonitorIndex: function() {
      var billingType = this.billingType;
      if (
        this.billingType == null ||
        this.billingType == "" ||
        this.billingType == undefined
      ) {
        billingType = 0;
      }
      this.$api.billing
        .searchBillMonitorIndex({
          type: 0,
          billingType: billingType,
          resourceType: 999
        })
        .then(res => {
          this.monitorIndexList = res.data;
        });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 查询资源类型
    queryResourceType: function() {
      this.$api.billing
        .searchResourceType("userName", getCookie(global.cookieName))
        .then(res => {
          this.resourceTypeList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.billingSearch {
  /* height: 51px; */
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/billing/BillingWarningSearch.vue